import { Image } from '@doist/marketist'

import type { ProductUIFrameBackgroundProps } from '@/components/product-ui/product-ui-frame-background/product-ui-frame-background'

import { ProductUISceneContainer } from '@/components/product-ui/product-ui-scene-container/product-ui-scene-container'

export function StaticImage({
    backgroundVariant,
    src,
}: {
    backgroundVariant: ProductUIFrameBackgroundProps['variant']
    src: string
}) {
    return (
        <ProductUISceneContainer backgroundVariant={backgroundVariant}>
            <Image src={src} width={590} height={550} style={{ zIndex: 1 }} alt={''} />
        </ProductUISceneContainer>
    )
}
